// Constants for not addressed reasons
export const NOT_ADDRESSED_REASONS = [
  { value: "Customer Out of City", label: "Customer Out of City" },
  { value: "Call Not Picked X 1", label: "Call Not Picked X 1" },
  { value: "Call Not Picked X 2", label: "Call Not Picked X 2" },
  { value: "Call Not Picked X 3", label: "Call Not Picked X 3" },
  { value: "Customer Will Call", label: "Customer Will Call" },
  { value: "Phone Off", label: "Phone Off" },
  { value: "DC Cloth in Kg", label: "DC Cloth in Kg" },
  { value: "Rate Issue", label: "Rate Issue" },
  { value: "Order by Mistake", label: "Order by Mistake" },
  { value: "set_preferred_time", label: "Set Preferred Time" },
  { value: "others", label: "Others" },
];

export const getReasonLabel = (value) => {
  const reason = NOT_ADDRESSED_REASONS.find((r) => r.value === value);
  return reason ? reason.label : value;
};
